// extracted by mini-css-extract-plugin
export default {"toggle":"Accordion2_toggle__yk4yF","dropdown__label":"Accordion2_dropdown__label__l33eO","arrow":"Accordion2_arrow__5ykJh","open":"Accordion2_open__ic-Dv"};